import { IExtendedDetailItemEntity } from "../pages/Quotation/Common/Interfaces/IItemEntity";

/**
 * Helper function to check if cart contains any warranty items
 * @param lineItems - Array of line items from the quotation
 * @returns true if any item has type 'warranty', false otherwise
 */
export const hasWarrantyItems = (lineItems: IExtendedDetailItemEntity[]): boolean => {
  return lineItems.some(item => item.type?.toLowerCase() === 'warranty');
};
